/* assets/js/main.js */
$(function () {
  'use strict';
  feed();

  // Shader canvas init (unchanged)
  const canvas = document.getElementById('shaderCanvas');
  if (canvas) {
    initShaderCanvas();
    window.addEventListener('resize', () => {
      resizeCanvasToDisplaySize(canvas);
    });
  }
});

/* Add lightbox to gallery images INSIDE POST CONTENT (uses lightbox.js) */
(function () {
  // This only affects .kg-image-card / .kg-gallery-card inside articles
  lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');
})();

/* Responsive video in post content */
(function () {
  const sources = [
    '.gh-content iframe[src*="youtube.com"]',
    '.gh-content iframe[src*="youtube-nocookie.com"]',
    '.gh-content iframe[src*="player.vimeo.com"]',
    '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
    '.gh-content object',
    '.gh-content embed'
  ];
  reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
  dropdown();
})();

/* Infinite scroll pagination (theme default) */
(function () {
  if (
    !document.body.classList.contains('home-template') &&
    !document.body.classList.contains('post-template') &&
    !document.getElementById('portfolio-template')
  ) {
    pagination();
  }
})();

/* Responsive HTML tables */
(function () {
  const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
  tables.forEach(function (table) {
    const wrapper = document.createElement('div');
    wrapper.className = 'gh-table';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
})();

/* =======================================================================
   Pixel zoom bar builder (uses the dedicated .pswp__pixelbar in pswp.hbs)
   - Buttons: 1× / 2× / 4× / 8×
   - Clicking a button LOCKS that scale across resizes
======================================================================= */
window.buildPixelBar = function buildPixelBar(gallery) {
  const root = gallery && gallery.template;
  if (!root) return;

  const bar = root.querySelector('.pswp__pixelbar');
  if (!bar) return;

  bar.innerHTML = ''; // prevent duplicates across slide changes

  const scales = [
    { label: '1×', scale: 1 },
    { label: '2×', scale: 2 },
    { label: '4×', scale: 4 },
    { label: '8×', scale: 8 }
  ];

  const buttons = [];

  function setActive(scaleVal) {
    buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.scale === String(scaleVal)));
  }

  function zoomTo(scaleVal) {
    const it   = gallery.currItem || {};
    const base = it.initialZoomLevel || 1;
    const max  = base * (gallery.options.maxSpreadZoom || 64);
    const target = Math.min(base * scaleVal, max);   // convert 1×/2×/4×/8× → zoom level
    gallery.zoomTo(target, { x: gallery.viewportSize.x / 2, y: gallery.viewportSize.y / 2 }, 0);
    gallery.__pixelDesiredScale = scaleVal;          // lock the user’s choice
    setActive(scaleVal);
  }

  scales.forEach(({ label, scale }) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pswp__pixel-zoom-btn';
    btn.dataset.scale = String(scale);
    btn.textContent = label;
    btn.addEventListener('click', (ev) => {
      ev.stopPropagation();
      zoomTo(scale);
    });
    bar.appendChild(btn);
    buttons.push(btn);
  });

  // keep the bar interactive (don’t close on click)
  bar.addEventListener('click', (e) => e.stopPropagation());
  bar.addEventListener('mousedown', (e) => e.stopPropagation());
};

/* Keep the pixel bar pinned just above the caption */
window.positionPixelBar = function positionPixelBar(gallery) {
  const root = gallery && gallery.template;
  if (!root) return;

  const bar = root.querySelector('.pswp__pixelbar');
  const cap = root.querySelector('.pswp__caption');
  if (!bar || !cap) return;

  const capHeight = cap.offsetHeight || 0;
  bar.style.bottom = capHeight + 'px';
};

/* =======================================================================
   Portfolio feed
   - Non-pixel pages: Masonry + PSWP binding here
   - Pixel pages (have .is-pixel-preview .pixel-preview-image): skip Masonry;
     pixelart.js (Packery) will handle layout & also bind PSWP itself.
======================================================================= */
function feed() {
  'use strict';

  const isPixelPage = !!document.querySelector('.is-pixel-preview .pixel-preview-image');
  if (isPixelPage) {
    // pixelart.js will run Packery + its own PSWP
    return;
  }

  const grid = document.querySelector('.post-feed');
  if (!grid) return;

  let masonry;
  imagesLoaded(grid, function () {
    masonry = new Masonry(grid, {
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      stamp: '.related-title',
      hiddenStyle: { transform: 'translateY(50px)', opacity: 0 },
      visibleStyle: { transform: 'translateY(0)', opacity: 1 }
    });

    masonry.on('layoutComplete', function () {
      grid.classList.add('initialized');
    });

    masonry.layout();

    function callback(items, loadNextPage) {
      imagesLoaded(items, function (loaded) {
        masonry.appended(items);
        masonry.layout();
        loaded.elements.forEach(function (item) {
          item.style.visibility = 'visible';
        });
        loadNextPage();
      });
    }
    pagination(true, callback, true);
  });

  // Lightbox for GRID items (PhotoSwipe)
  pswp('.post-feed', '.post', '.post-link', '.post-caption', false);
}

/* =======================================================================
   PhotoSwipe binding for GRID (non-pixel pages)
   - Default 4× (else 2×, else 1×) on open & on slide change
   - Keep the SAME scale across resizes (no auto re-fit)
======================================================================= */
function pswp(container, element, trigger, caption, isGallery) {
  function parseThumbnailElements(el) {
    const items = [];
    $(el)
      .find(element)
      .each(function (_i, v) {
        const gridEl = $(v);
        const linkEl = gridEl.find(trigger);
        const item = {
          src: isGallery ? gridEl.find('img').attr('src') : linkEl.attr('href'),
          w: 0,
          h: 0
        };
        if (caption && gridEl.find(caption).length) {
          item.title = gridEl.find(caption).html();
        }
        items.push(item);
      });
    return items;
  }

  function openPhotoSwipe(index, galleryElement) {
    const pswpElement = document.querySelectorAll('.pswp')[0];
    const items = parseThumbnailElements(galleryElement);

    const options = {
      closeOnScroll: false,
      history: false,
      index: index,
      shareEl: false,
      showAnimationDuration: 0,   // open = instant (keep)
      hideAnimationDuration: 200, // close = fade time
      showHideOpacity: true,      // fade-only open/close
      maxSpreadZoom: 64,
      getThumbBoundsFn: null      // prevent zoom-back-to-thumb
    };
    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

    gallery.options.getDoubleTapZoom = function () {
      // Return current zoom level → clicking/tapping the image won’t change zoom
      return gallery.getZoomLevel();
    };

    // Crisp scaling CSS toggle for pixel pages
    const isPixelArt =
      !!document.querySelector('.post-feed[data-layout="pixel-pack"]') ||
      items.some((it) => it.el && it.el.classList && it.el.classList.contains('pixel-preview-image'));
    pswpElement.classList.toggle('pswp--pixel', !!isPixelArt);

    // Ensure items have w/h
    gallery.listen('gettingData', function (_idx, item) {
      if (!item.w || !item.h) {
        const img = new Image();
        img.onload = function () {
          item.w = this.width;
          item.h = this.height;
          gallery.updateSize(true);
        };
        img.src = item.src;
      }
    });

    // --------- LOCKED DEFAULT SCALE LOGIC ---------------------------------
    gallery.__pixelDesiredScale = null; // null = not chosen by user yet
    let _pxAppliedIndex = -1;

    function pickDefault(item, vp) {
      if (!item || !item.w || !item.h || !vp) return null;
      const cand = [4, 2, 1];
      for (let s of cand) {
        if (item.w * s <= vp.x && item.h * s <= vp.y) return s;
      }
      return null;
    }

    function highlight(scale) {
      const bar = gallery.template && gallery.template.querySelector('.pswp__pixelbar');
      if (!bar) return;
      bar.querySelectorAll('.pswp__pixel-zoom-btn')
        .forEach(b => b.classList.toggle('is-active', b.dataset.scale === String(scale)));
    }

    function setScale(scale, force = false) {
      const idx = gallery.getCurrentIndex();
      const vp  = gallery.viewportSize;
      const it  = gallery.currItem;
      if (!vp || !it) return;

      if (!force && _pxAppliedIndex === idx && gallery.__pixelDesiredScale === scale) return;

      const base = it.initialZoomLevel || 1;
      const max  = base * (gallery.options.maxSpreadZoom || 64);
      const target = Math.min(base * scale, max);   // convert 1×/2×/4×/8× → zoom level

      gallery.zoomTo(target, { x: vp.x / 2, y: vp.y / 2 }, 0);

      gallery.__pixelDesiredScale = scale;          // lock scale (default or user)
      _pxAppliedIndex = idx;
      highlight(scale);
    }

    function applyDefault(force = false) {
      // If the user already clicked a button, don’t overwrite
      if (!force && gallery.__pixelDesiredScale != null) return;

      const it = gallery.currItem, vp = gallery.viewportSize;
      const s = pickDefault(it, vp);
      if (s) setScale(s, true);
    }
    // ----------------------------------------------------------------------

    // Build bar & set default once visible
    gallery.listen('initialZoomInEnd', function () {
      window.buildPixelBar && window.buildPixelBar(gallery);
      window.positionPixelBar && window.positionPixelBar(gallery);
      applyDefault(true); // choose 4×→2×→1× on open
    });

    // If the full image loads later, re-try default for current slide (only if user hasn't clicked)
    gallery.listen('imageLoadComplete', function (i) {
      if (i === gallery.getCurrentIndex()) applyDefault(true);
    });

    // On slide change: new default (fresh lock for the new slide)
    gallery.listen('afterChange', function () {
      window.positionPixelBar && window.positionPixelBar(gallery);
      gallery.__pixelDesiredScale = null;
      _pxAppliedIndex = -1;
      applyDefault(true);
    });

    // Keep the SAME scale on viewport resize (no auto re-fit)
    gallery.listen('resize', function () {
      window.positionPixelBar && window.positionPixelBar(gallery);
      if (gallery.__pixelDesiredScale != null) {
        setScale(gallery.__pixelDesiredScale, true);
      }
    });

    // 1) Disable double-tap zoom (mobile): return current zoom so it’s a no-op
    gallery.options.getDoubleTapZoom = function () {
      return gallery.getZoomLevel();
    };

    // 2) Disable desktop click-to-zoom toggle
    gallery.toggleDesktopZoom = function () {
      /* no-op */
    };

    // 3) Eat image clicks in the capture phase so PSWP doesn't see them
    //    (prevents any internal zoom toggle paths)
    (function preventImageClickZoom(g) {
      // For mouse
      const wrap = g.scrollWrap || (g.template && g.template.querySelector('.pswp__scroll-wrap'));
      if (wrap) {
        wrap.addEventListener('click', function (ev) {
          const t = ev.target;
          if (t && t.classList && t.classList.contains('pswp__img')) {
            ev.stopPropagation();
            ev.preventDefault();
            // keep the current zoom level as-is
          }
        }, true); // capture phase
      }
      // For touch (safety)
      if (g.template) {
        g.template.addEventListener('touchend', function (ev) {
          const t = ev.target;
          if (t && t.classList && t.classList.contains('pswp__img')) {
            ev.stopPropagation();
          }
        }, true);
      }
    })(gallery);

    // 4) Close should **fade**, not zoom-shrink back to fit
    gallery.options.showHideOpacity = true;     // fade animation
    gallery.options.getThumbBoundsFn = null;    // no zoom-to-thumb on close
    // (You can tweak timing if you want)
    // gallery.options.hideAnimationDuration = 200;


    gallery.listen('close', function () {
      if (gallery.template) {
        gallery.template.classList.add('pswp--force-fade');
      }
    });

    // Hide image immediately when closing so you never see a 1× snap/top-left jump
    gallery.listen('initialZoomOut', function () {
      var root = gallery.template;
      if (!root) return;

      // Add a class so CSS can force-hide the image/zoom-wrap during close
      root.classList.add('pswp--closing-hide-imgs');

      // Belt-and-suspenders: hide current wraps instantly via inline style
      var nodes = root.querySelectorAll('.pswp__zoom-wrap, .pswp__img');
      nodes.forEach(function (el) { el.style.opacity = '0'; });
    });

    gallery.init();
  }

  $(container).on('click', trigger, function (e) {
    e.preventDefault();
    const index = $(e.target).closest(container).find(element).index($(e.target).closest(element));
    const clickedGallery = $(e.target).closest(container);
    openPhotoSwipe(index, clickedGallery[0]);
    return false;
  });
}
